<template>
  <div>
    <VerticalMedias :medias="medias"
                    :loading="loading"
                    :pagination="pagination"
                    :paginationMode="paginationMode"
                    :isPaid="isPaid"
                    :digitalItemId="digitalItemId"
                    :gallery="gallery"
                    @nextPage="$emit('nextPage', $event)"
                    @select="$emit('select', $event)"
                    v-if="gallery.layout===galleryLayouts.VERTICAL"/>

    <HorizontalMedias :medias="medias"
                      :loading="loading"
                      :pagination="pagination"
                      :isPaid="isPaid"
                      :digitalItemId="digitalItemId"
                      :gallery="gallery"
                      @nextPage="$emit('nextPage')"
                      @select="$emit('select', $event)"
                      v-if="gallery.layout===galleryLayouts.HORIZONTAL"/>
  </div>
</template>

<script>
import VerticalMedias from "@/domain/galleries/layouts/VerticalMedias.vue";
import {galleryLayouts} from "@/domain/galleries/constants";
import HorizontalMedias from "@/domain/galleries/layouts/HorizontalMedias.vue";


export default {
  name: 'MediasLayout',
  components: {HorizontalMedias, VerticalMedias},
  emits: ['nextPage', 'select'],
  props: {
    medias: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    pagination: {
      type: Object,
      required: false
    },
    paginationMode: {
      type: String,
      required: false
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: true
    }
  },
  computed: {
    galleryLayouts() {
      return galleryLayouts
    }
  }
}
</script>


<style scoped>

</style>